<template>
  <edit-template :confirm-loading="confirmLoading" :data-loading="dataLoading" flag="mu" style="background: #F7F7F7 !important;" type="card" @confirm="submit">
    <div style="background: #FFF">
      <el-form ref="form" :model="form" :rules="rules" label-width="150rem">
        <ZCard title="账号信息">
          <el-form-item label="账号" prop="username">
            <el-input :value="form.username" placeholder="请输入入职教师手机号" type="number" @input="onChangeMobile"/>
          </el-form-item>
          <el-form-item label="姓名" required>
            <el-form-item class="inline-form-item" label-width="0" prop="name">
              <el-input v-model="form.name" placeholder="请输入教师姓名" type="text"/>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="id_card">
              <el-input v-model="form.id_card" maxlength="18" placeholder="请输入教师身份证号码" @input="(val)=>{this.form.id_card = val.toUpperCase().replace(/[^0-9X]/g, '')}"/>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="nation">
              <el-select v-model="form.nation" :loading="loading" placeholder="请选择教师民族">
                <el-option v-for="item in nationOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item label="岗位信息" required>
            <el-form-item class="inline-form-item" label-width="0" prop="role_type">
              <el-select v-model="form.role_type" placeholder="请选择岗位类型" @change="onRoleTypeChange">
                <el-option v-for="item in roleTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <div v-if="form.role_type != null && form.role_type !== ''" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                岗位类型
              </div>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="employment">
              <!-- <el-select v-model="form.employment" placeholder="请选择岗位及任职情况">
                <el-option v-for="item in postAndTenureStatus" :key="item" :label="item" :value="item"></el-option>
              </el-select> -->
              <el-cascader filterable :props="{value: 'id', label: 'name', children: 'teacher_employment'}" v-model="form.employment" :options="roleList" placeholder="请选择岗位及任职情况"></el-cascader>
              <div v-if="form.employment != null && form.employment !== ''" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                岗位/任职情况
              </div>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="subject">
              <el-cascader v-model="form.subject" :options="subjects" placeholder="请选择教学学科"></el-cascader>
              <div v-if="form.subject && form.subject.length" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                教学学科
              </div>
            </el-form-item>
          </el-form-item>
          <el-form-item v-if="roleInfo.is_admin" label="是否为集团员工" prop="is_group_member">
            <el-radio-group v-model="form.is_group_member" @input="getSchool($event,true)">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="所属校区" prop="school">
            <el-select v-model="form.school" :disabled="!roleInfo.is_admin || (roleInfo.is_admin && form.is_group_member == null)">
              <el-option v-for="item in schoolList" :key="item.id" :label="item.school_name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否为部门负责人" prop="department_head">
            <el-input v-show="false" v-model="form.department_head" placeholder="是否为部门负责人" type="text"/>
            <el-radio v-model="form.department_head" :label="1">是</el-radio>
            <el-radio v-model="form.department_head" :label="0">否</el-radio>
          </el-form-item>
        </ZCard>
        <div style="height: 24px;background: #F7F7F7"></div>
        <ZCard title="教师基础信息">
          <el-form-item label="入职时间" prop="entry_time" >
            <el-date-picker v-model="form.entry_time" format="yyyy-MM-dd" placeholder="选择日期" type="date" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="教龄" required>
            <el-form-item class="inline-form-item" label-width="0" prop="teaching_experience">
              <el-input v-model.number="form.teaching_experience" placeholder="请输入教龄" type="number"/>
            </el-form-item>
          </el-form-item>
          <el-form-item label="最高学历及政治面貌" required>
            <el-form-item class="inline-form-item" label-width="0" prop="education">
              <el-select v-model="form.education" placeholder="请选择最高学历">
                <el-option v-for="item in educationLevels" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div v-if="form.education != null && form.education !== ''" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                最高学历
              </div>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="political_outlook">
              <el-select v-model="form.political_outlook" placeholder="请选择政治面貌">
                <el-option v-for="item in politicalStatus" :key="item.political_id" :label="item.political_outlook" :value="item.political_id"></el-option>
              </el-select>
              <div v-if="form.political_outlook != null && form.political_outlook !== ''" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                政治面貌
              </div>
            </el-form-item>
          </el-form-item>
          <el-form-item label="专业及院校" required>
            <el-form-item class="inline-form-item" label-width="0" prop="graduated_from">
              <el-input v-model="form.graduated_from" maxlength="20" placeholder="请输入毕业院校" type="text"/>
              <div v-if="form.graduated_from" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                毕业院校
              </div>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="major">
              <el-input v-model="form.major" maxlength="20" placeholder="请输入所学专业" type="text"/>
              <div v-if="form.major" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                所学专业
              </div>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="is_normal">
              <el-select v-model="form.is_normal" placeholder="是否为师范专业">
                <el-option label="是" value="1">是</el-option>
                <el-option label="否" value="0">否</el-option>
              </el-select>
              <div v-if="form.is_normal != null && form.is_normal !== ''" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                是否为师范专业
              </div>
            </el-form-item>
          </el-form-item>
          <el-form-item label="是否有教师资格证" required>
            <el-form-item class="inline-form-item" label-width="0" prop="teacher_certificate">
              <el-select v-model="form.teacher_certificate" placeholder="请选择是否有教师资格证">
                <el-option label="是" :value="1">是</el-option>
                <el-option label="否" :value="0">否</el-option>
              </el-select>
              <div v-if="form.teacher_certificate != null && form.teacher_certificate !== ''" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                是否有教师资格证
              </div>
            </el-form-item>
            -
            <el-form-item class="inline-form-item" label-width="0" prop="teacher_title">
              <el-select v-model="form.teacher_title" placeholder="请选择教师职称">
                <el-option v-for="item in teacherTitle" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <div v-if="form.teacher_title" style="height: 0;font-size: 12px;color: #ccc;line-height: 20px;">
                教师职称
              </div>
            </el-form-item>
          </el-form-item>
        </ZCard>
      </el-form>
    </div>
  </edit-template>
</template>

<script>
import {getSubject} from './api';
import ZCard from "@/components/common/Card.vue";

export default {
  components: {ZCard},
  _config: {"route": {"path": "add", "meta": {"title": "新增"}}},
  data() {
    return {
      roleInfo: {},
      loading: false,
      dataLoading: false,
      confirmLoading: false,
      form: {
        username: null, // 手机号
        name: null, // 姓名
        id_card: null,// 身份证号
        nation: null, // 民族
        school: null, // 校区
        is_group_member: null, // 是否为集团员工
        department_head: null, // 是否为部门负责人
        role_type: null,
        employment: null,
        subject: null,
        entry_time: null,
        teaching_experience: null,
        education: null,
        political_outlook: null,
        graduated_from: null,
        major: null,
        is_normal: null,
        teacher_certificate: null,
        teacher_title: null
      },
      nationOptions: [],
      subjects: [], // 教学学科列表
      schoolList: [],
      // 岗位列表
      roleTypeList: [],
      // 岗位任职情况
      postAndTenureStatus: [],
      // 教师职称
      teacherTitle: [],
      // 政治面貌
      politicalStatus: [],
      // 学历
      "educationLevels": [
        {"value": 7, "label": "博士研究生"},
        {"value": 6, "label": "硕士研究生"},
        {"value": 5, "label": "本科"},
        {"value": 4, "label": "专科"},
        {"value": 3, "label": "高中"},
        {"value": 2, "label": "初中"},
        {"value": 1, "label": "小学"}
      ],
      // 岗位列表
      roleList: [],
      rules: {
        username: [{required: true, message: '请输入手机号', trigger: 'change'}, {min: 11, max: 11, message: "请输入正确的手机号", trigger: "change"}],
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        id_card: [{required: true, pattern: /^((\d{17})|(\d{14}))[0-9X]$/, message: "请输入正确的身份证号", trigger: "change"}],
        school: [{required: true, message: '请选择校区', trigger: 'change'}],
        nation: [{required: true, message: '请输入民族', trigger: 'change'}],
        is_group_member: [{required: true, message: '请选择是否为集团员工', trigger: 'change'}],
        department_head: [{required: true, message: '请选择是否为部门负责人', trigger: 'change'}],
        role_type: [{required: true, message: '请选择选择岗位', trigger: 'change'}],
        // role_type: [{required: true, message: '请选择岗位类型', trigger: 'change'}],
        employment: [{required: true, message: '请选择岗位及任职情况', trigger: 'change'}],
        subject: [{required: true, message: '请选择教学学科', trigger: 'change'}],
        entry_time: [{required: true, message: '请选择入职时间', trigger: 'change'}],
        teaching_experience: [
          {type: 'number', required: true, message: '请输入教龄', trigger: 'change'},
          {type: 'number', min: 0, message: '教龄不能为负数', trigger: 'change'},
          {type: 'number', max: 100, message: '教龄不能超过100', trigger: 'change'},
          {pattern: /^\d+(\.\d{1})?$/, message: '教龄最多只能有一位小数', trigger: 'change'}
        ],
        education: [{required: true, message: '请选择最高学历', trigger: 'change'}],
        political_outlook: [{required: true, message: '请选择政治面貌', trigger: 'change'}],
        is_normal: [{required: true, message: '请选择是否为师范专业', trigger: 'change'}],
        teacher_certificate: [{required: true, message: '请选择是否有教师资格证', trigger: 'change'}],
        teacher_title: [{required: true, message: '请选择教师职称', trigger: 'change'}],
        graduated_from: [{required: true, message: '请输入毕业院校', trigger: 'change'}],
        major: [{required: true, message: '请输入所学专业', trigger: 'change'}],
      },
      keyword: '',
    };
  },
  mounted() {
    this.getData().finally(() => this.dataLoading = false);
  },
  methods: {
    // 限制手机号长度
    onChangeMobile(val) {
      if (val.length <= 11)
        this.form.username = val;
    },
    getSchool(is_group_member, isLoading = false) {
      this.form.school = null;
      if (isLoading) this.dataLoading = true;
      // 获取校区
      return this.$_axios2.get("api/permission/school-list", {
        logic: 1,
        params: {
          is_group_member
        }
      }).then(res => {
        this.schoolList = res.data;
      }).finally(res => {
        if (isLoading) this.dataLoading = false;
      })
    },
    // 获取数据
    async getData() {
      this.dataLoading = true;
      // 获取岗位类型
      await this.$_axios2.get("api/permission/role-type", {logic: 1}).then(res => {
        this.roleTypeList = res.data;
      }).catch(err => {
        console.log(err.msg || err.message);
      })
      // 获取角色类型
      await this.$utils.loginApi.getRole().then(res => {
        this.roleInfo = res.data;
      }).catch(err => {
        console.log(err.msg || err.message);
      })
      // 获取教学学科
      await getSubject().then(res => {
        this.subjects = JSON.parse(
            JSON.stringify(res.data.data).replace(/id/g, 'value').replace(/subject_name/g, 'label').replace(/child/g, 'children'),
        );
      });

      // 如果为非管理员 获取校区
      let {is_admin} = this.roleInfo;
      if (!is_admin) {
        await this.getSchool(0);
        this.form.school = this.schoolList[0].id;
      }
    },
    // 岗位类型改变时触发
    onRoleTypeChange(e) {
      this.form.employment = null;
      this.dataLoading = true;
      // this.form.role_type = null;
      this.$_axios2.get("api/permission/role-type-list", {
        params: {
          level: e
        },
        logic: 1
      }).then(res => {
        this.roleList = res.data;
      }).finally(() => this.dataLoading = false)
    },
    // 提交
    submit() {
      this.$refs.form.validate(res => {
        if (res) {
          this.confirmLoading = true;
          let params = Object.assign({}, this.form);
          params.is_group_member = params.is_group_member || 0;
          delete params.role_type;
          this.$_axios2.post("api/account/add-account", params, {logic: 1}).then(res => {
            this.$message.success("添加成功");
            this.$store.commit("setPage", 1);
            this.$router.back();
          }).finally(() => this.confirmLoading = false)
        }
      });
    },
  },

  created() {
    this.$_axios2.get('api/common/nation').then(res => {
      this.nationOptions = res.data.data
    })
    this.$_axios2.get('api/1v1/sys-config/get', {params: {key: 'teacher_employment'}}).then(res => {
      this.postAndTenureStatus = res.data.data
    })
    this.$_axios2.get('api/1v1/sys-config/get', {params: {key: 'teacher_title'}}).then(res => {
      this.teacherTitle = res.data.data
    })
    this.$_axios2.get('api/account/political-type').then(res => {
      this.politicalStatus = res.data.data
    })
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  min-width: 100rem;
  margin: 10rem;
}

::v-deep .el-input--small .el-input__inner {
  width: 300rem;
  height: 40rem;
  color: #999;
}

::v-deep .el-checkbox-group {
  max-height: 400rem !important;
  overflow: scroll;
}

::v-deep .inline-form-item {
  display: inline-block;
  vertical-align: top;
}

::v-deep .inline-form-item .el-form-item__error {
  white-space: nowrap;
}

.t-edit-template-footer {
  background: #FFF !important;
  overflow: hidden;
}

</style>
